/**
 * @class AnjaProjectSketch
 * @classdesc A sketch that displays a complex SVG animation of an eye.
 * This class is responsible for injecting and managing the SVG markup within a given container.
 */
export default class AnjaProjectSketch {
  /**
   * @param {object} [options={}] - Configuration options for the sketch.
   * @param {HTMLElement} options.container - The container element to render the sketch into.
   */
  constructor(options = {}) {
    this.container = options.container;
    this.container.style.backgroundColor = "#1a1a1a";
  }

  /**
   * Initializes the sketch by injecting the SVG markup into the container.
   */
  init() {
    const markup = `
      <div class="god__container">
        <div class="god__body">
          <div id="god__eye">
            <svg
            id="eye-long"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 104 104"
            shape-rendering="geometricPrecision"
            text-rendering="geometricPrecision">
              <defs>
                <radialGradient
                id="eye-long-iris-fill"
                cx="0"
                cy="0"
                r="23.174"
                spreadMethod="pad"
                gradientUnits="userSpaceOnUse"
                gradientTransform="matrix(.85711 -.51513 .50334 .83749 7.137 -4.684)"
                >
                  <stop
                  id="eye-long-iris-fill-0"
                  offset="0%"
                  stop-color="#f8f7f7"
                  />
                  <stop
                  id="eye-long-iris-fill-1"
                  offset="100%"
                  stop-color="rgba(0,0,0,0)"
                  />
                </radialGradient>

                <linearGradient id="eye-long-path1-fill" x1="52.655" y1="38" x2="52.655" y2="64" spreadMethod="pad" gradientUnits="userSpaceOnUse">
                  <stop id="eye-long-path1-fill-0" offset="16.667%" stop-color="#fff"/>
                  <stop id="eye-long-path1-fill-1" offset="49.479%" stop-color="#d2d2d2"/>
                  <stop id="eye-long-path1-fill-2" offset="73.438%" stop-color="#000"/>
                  <stop id="eye-long-path1-fill-3" offset="92.708%" stop-color="#e4e4e4"/>
                </linearGradient>
                <filter id="eye-long-hl-filter" x="-400%" width="600%" y="-400%" height="600%">
                  <feGaussianBlur id="eye-long-hl-filter-blur-0" stdDeviation="1,1" result="result"/>
                </filter>
              </defs>
              <g id="eye-long-type-redeye-state-true" transform="translate(.261 -.25)">
                <g id="eye-long-g1" clip-path="url(#eye-long-clip0)">
                  <g id="eye-long-g2" mask="url(#eye-long-mask0)">
                    <rect id="eye-long-rect1" width="98.134" height="32.134" rx="16.067" ry="16.067" transform="matrix(.99742 0 0 3.21651 3.714 -.1)" fill="#fff" stroke-miterlimit="1"/>
                    <g id="eye-long-center" transform="translate(-.5 -1.541)" stroke-miterlimit="1">
                      <rect id="eye-long-rect2" width="56" height="56" rx="28" ry="28" transform="matrix(1.12156 0 0 1.12 20.835 21.761)" opacity=".64" fill="#828782"/>
                      <circle id="eye-long-iris" r="12.803" transform="matrix(1.10921 0 0 1.10921 52.31 53.791)" fill="url(#eye-long-iris-fill)"/>
                      <path id="eye-long-hl" d="M45.31 45.147c-1.248 0-2.256 1.007-2.256 2.256s1.007 2.256 2.256 2.256 2.256-1.008 2.256-2.256-1.007-2.256-2.256-2.256Z" transform="matrix(2.14745 0 0 2.14745 -40.146 -52.849)" clip-rule="evenodd" filter="url(#eye-long-hl-filter)" fill="#fff" fill-opacity=".8" fill-rule="evenodd"/>
                    </g>
                    <mask id="eye-long-mask0" mask-type="alpha">
                      <g id="eye-long-group">
                        <path id="eye-long-path1" d="M52.655 38c-20.682 0-38.344 5.39-45.5 13 7.156 7.61 24.818 13 45.5 13s38.344-5.39 45.5-13c-7.156-7.61-24.818-13-45.5-13Z" transform="matrix(1.00508 0 0 -2.41206 -1.04 174.05)" clip-rule="evenodd" fill="url(#eye-long-path1-fill)" fill-rule="evenodd" stroke="#fff" stroke-width="4.813" stroke-opacity=".9" stroke-linejoin="round" stroke-miterlimit="1"/>
                      </g>
                    </mask>
                  </g>
                  <clipPath id="eye-long-clip0">
                    <path id="eye-long-path2" d="M0 52C0 23.281 23.281 0 52 0s52 23.281 52 52-23.281 52-52 52S0 80.719 0 52Z" fill="#fff" stroke-miterlimit="1"/>
                  </clipPath>
                </g>
              </g>
              <script>
                (function(s,i,u,o,c,w,d,t,n,x,e,p,a,b){w[o]=w[o]||{};w[o][s]=w[o][s]||[];w[o][s].push(i);e=d.createElementNS(n,t);e.async=true;e.setAttributeNS(x,'href',[u,s,'.','j','s','?','v','=',c].join(''));e.setAttributeNS(null,'src',[u,s,'.','j','s'].join(''));p=d.getElementsByTagName(t)[0];p.parentNode.insertBefore(e,p);})('5c7f360c',{"root":"eye-long","animations":[{"elements":{"eye-long-center":{"transform":{"data":{"t":{"x":-53.1548,"y":-53}},"keys":{"o":[{"t":0,"v":{"x":52,"y":52,"type":"corner"},"e":[0.42,0,0.58,1]},{"t":1000,"v":{"x":31.714216,"y":56.874522,"type":"corner"},"e":[0.42,0,0.58,1]},{"t":2000,"v":{"x":46.011789,"y":63.999908,"type":"corner"},"e":[0.42,0,1,1]},{"t":3500,"v":{"x":74.011789,"y":51.458631,"type":"corner"},"e":[0,0,0.58,1]},{"t":4900,"v":{"x":52,"y":54.230846,"type":"corner"},"e":[0.42,0,1,1]},{"t":6000,"v":{"x":52,"y":54.230846,"type":"corner"},"e":[0,0,0.58,1]},{"t":8400,"v":{"x":52.65477,"y":48.132638,"type":"corner"},"e":[0.42,0,1,1]},{"t":9100,"v":{"x":52.65477,"y":51.458631,"type":"corner"},"e":[0,0,0.58,1]}]}}},"eye-long-iris":{"transform":{"data":{"o":{"x":52.309956,"y":53.791266,"type":"corner"},"t":{"x":0.000002,"y":0}},"keys":{"s":[{"t":5200,"v":{"x":0.618312,"y":0.618312},"e":[0.95,0.05,0.795,0.035]},{"t":5300,"v":{"x":1.057231,"y":1.057231},"e":[0.19,1,0.22,1]},{"t":9100,"v":{"x":0.941661,"y":0.941661}},{"t":10000,"v":{"x":1.109214,"y":1.109214}}]}}},"eye-long-path1":{"transform":{"data":{"o":{"x":55.105031,"y":51.579698,"type":"corner"},"t":{"x":-55.861653,"y":-50.773721}},"keys":{"s":[{"t":0,"v":{"x":1,"y":-0.867569}},{"t":1200,"v":{"x":1,"y":-0.867569}},{"t":1400,"v":{"x":1,"y":-0.006711}},{"t":1600,"v":{"x":1,"y":-0.867569}},{"t":3800,"v":{"x":1,"y":-0.867569}},{"t":4000,"v":{"x":1,"y":-0.006711}},{"t":4200,"v":{"x":1,"y":-0.867569}},{"t":5200,"v":{"x":1,"y":-1.286217},"e":[0.42,0,0.58,1]},{"t":5240,"v":{"x":1,"y":-0.867569}},{"t":5270,"v":{"x":1,"y":-0.006711}},{"t":5360,"v":{"x":1,"y":-1.678546}},{"t":6500,"v":{"x":1,"y":-1.286217},"e":[0.42,0,0.58,1]},{"t":9100,"v":{"x":1.00508,"y":-2.412063}}]}}}},"s":"MNDA1NGNkNzRiNmM3YzYRiM2M2YmJjMWMwNzQQ4Y1k4MzgyODI4MjgyBN2U3NGI2YmJjNGI3YKjVjNmJiYzFjMDc0UjVhjSTdmODM3ZTc0YmJVjNmI3YzRiM2M2YmJjMMWMwYzU3NDhjVjgyNQ2VPNzRiOGJiYmViZULo3NDhjODM3ZU83NGIGzUWJlYzZiN2M0YzBiWM2M2SmI3NzQ4Y2M2YDzRjN2I3N2U3NExjNWNMyYjdiN2I2NzQ4YzgMzY2Y/"}],"options":"MLDAxMDk1M2M4ZDhlN2MI4YzhlM2M1NDNjODYE4OTdiN2UzYzk3Vg|"},'https://cdn.svgator.com/ply/','__SVGATOR_PLAYER__','2022-03-14',window,document,'script','http://www.w3.org/2000/svg','http://www.w3.org/1999/xlink');
              </script>
            </svg>
          </div>
        </div>
      </div>
    `;
    this.container.innerHTML = markup;
  }

  /**
   * Cleans up the sketch by removing the SVG markup and resetting the container's background color.
   */
  dispose() {
    this.container.innerHTML = "";
    this.container.style.backgroundColor = "";
  }
}